import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, googleProvider } from "../config/firebase"; // Import Firebase
import { signInWithPopup } from "firebase/auth"; // Import Firebase
import loginHero from "../assets/login_hero.png";
import AppIcon from "../assets/sayq-fav.svg";

const API = "https://api18081113.queroapp.pl";

export default function UserAuth() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        // ... (existing implementation)
        e.preventDefault();
        if (!email || !password) {
            setError("Podaj email i hasło");
            return;
        }

        setLoading(true);
        setError("");

        try {
            const res = await fetch(`${API}/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, password }),
            });

            const data = await res.json();

            if (res.ok && data.secretId) {
                localStorage.setItem("authToken", "admin-logged-in");
                localStorage.setItem("secretId", data.secretId);
                // navigate to dashboard
                navigate("/admin-panel");
            } else {
                setError(data.error || "Błąd logowania. Sprawdź dane.");
            }
        } catch (err) {
            console.error(err);
            setError("Błąd połączenia z serwerem.");
        } finally {
            setLoading(false);
        }
    };

    const handleSocialLogin = async (providerName, authProvider) => {
        setError("");
        try {
            const result = await signInWithPopup(auth, authProvider);
            const user = result.user;

            const res = await fetch(`${API}/social-auth`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email: user.email, uid: user.uid, provider: providerName })
            });

            const data = await res.json();
            console.log(`DEBUG: Social auth response (${providerName})`, {
                status: res.status,
                success: data.success,
                secretId: data.secretId
            });

            if (data.success && data.secretId) {
                localStorage.setItem("authToken", "admin-logged-in");
                localStorage.setItem("secretId", data.secretId);

                // If backend returned 201, it's a new account -> go to wizard
                if (res.status === 201) {
                    console.log("DEBUG: New account detected (201), navigating to wizard...");
                    navigate(`/RegisterEvent/${data.secretId}`);
                } else {
                    console.log("DEBUG: Existing account detected (200), navigating to dashboard...");
                    navigate("/admin-panel");
                }
            } else {
                setError(data.error || `Autoryzacja ${providerName} nie powiodła się.`);
            }
        } catch (err) {
            console.error(`${providerName} Auth Error:`, err);
            // Show detailed message for debugging
            setError(`Błąd logowania przez ${providerName}: ${err.message}`);
        }
    };

    return (
        <div className="d-flex w-100 vh-100 overflow-hidden bg-white font-sans">
            {/* LEFT COLUMN: FORM */}
            <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center p-4 p-md-5 relative">

                <div className="w-100" style={{ maxWidth: "420px" }}>
                    {/* Logo Placeholder */}
                    <div className="mb-4 text-center text-md-start">
                        <img src={AppIcon} alt="SayQ" className="rounded-3" style={{ width: 64, height: 64, objectFit: 'contain' }} />
                    </div>

                    <h1 className="fw-bold mb-2 text-dark" style={{ fontSize: '2rem' }}>Witaj ponownie!</h1>
                    <p className="text-secondary mb-5">Zaloguj się, aby zarządzać swoim eventem.</p>

                    <form onSubmit={handleLogin}>
                        <div className="mb-4">
                            <label className="form-label text-uppercase small fw-bold text-secondary ls-1" style={{ fontSize: '0.75rem' }}>Adres E-mail</label>
                            <input
                                type="email"
                                className="form-control form-control-lg bg-light border-0 rounded-3 py-3 px-3"
                                placeholder="name@example.com"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                            />
                        </div>

                        <div className="mb-4">
                            <label className="form-label text-uppercase small fw-bold text-secondary ls-1" style={{ fontSize: '0.75rem' }}>Hasło</label>
                            <input
                                type="password"
                                className="form-control form-control-lg bg-light border-0 rounded-3 py-3 px-3"
                                placeholder="••••••••••••"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                            />
                        </div>

                        {error && (
                            <div className="alert alert-danger py-2 text-center text-sm mb-4 rounded-3 border-0 bg-danger-subtle text-danger fw-bold">
                                {error}
                            </div>
                        )}

                        <button
                            type="submit"
                            className="btn btn-primary w-100 btn-lg rounded-pill fw-bold py-3 mb-4 shadow-primary hover-lift"
                            disabled={loading}
                            style={{ fontSize: '0.9rem', letterSpacing: '0.5px' }}
                        >
                            {loading ? "Logowanie..." : "ZALOGUJ SIĘ"}
                        </button>

                        <div className="position-relative text-center mb-4">
                            <hr className="text-secondary opacity-25" />
                            <span className="position-absolute top-50 start-50 translate-middle bg-white px-3 text-muted small">lub kontynuuj z</span>
                        </div>

                        <button
                            type="button"
                            onClick={() => handleSocialLogin('Google', googleProvider)}
                            className="btn btn-outline-light text-dark border border-2 w-100 rounded-pill py-3 fw-bold d-flex align-items-center justify-content-center gap-2 hover-bg-light"
                        >
                            <img src="https://www.svgrepo.com/show/475656/google-color.svg" alt="G" style={{ width: 20 }} />
                            Google
                        </button>
                    </form>

                    <div className="mt-5 text-center">
                        <span className="text-secondary small">Nie masz jeszcze konta? </span>
                        <a href="#" onClick={(e) => { e.preventDefault(); navigate("/EventRegister") }} className="text-primary fw-bold text-decoration-none small">
                            Zarejestruj się
                        </a>
                    </div>

                    {/* Guest Link underneath */}


                </div>
            </div>

            {/* RIGHT COLUMN: HERO IMAGE */}
            <div className="d-none d-md-block col-md-6 p-0 position-relative bg-dark overflow-hidden">
                <img
                    src={loginHero}
                    alt="Login Hero"
                    className="w-100 h-100 object-fit-cover opacity-75"
                    style={{ objectPosition: 'center top' }}
                />
                <div className="position-absolute top-0 start-0 w-100 h-100 bg-gradient-to-t from-black to-transparent opacity-50" style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)' }}></div>

                <div className="position-absolute bottom-0 start-0 w-100 p-5 mb-5 text-white">
                    <h2 className="display-4 fw-bold mb-3">Twórz eventy,<br />które inspirują.</h2>
                    <p className="lead opacity-75" style={{ maxWidth: 400 }}>Dołącz do tysięcy organizatorów korzystających z SayQ App, aby angażować publiczność w czasie rzeczywistym.</p>
                </div>
            </div>

            <style>{`
        .font-sans { font-family: 'Check', 'Inter', system-ui, -apple-system, sans-serif; }
        .ls-1 { letter-spacing: 1px; }
        .hover-lift { transition: transform 0.2s, box-shadow 0.2s; }
        .hover-lift:hover { transform: translateY(-2px); box-shadow: 0 10px 25px -5px rgba(37, 99, 235, 0.4); }
        .hover-bg-light:hover { background-color: #f8f9fa; }
        .shadow-primary { box-shadow: 0 4px 14px 0 rgba(37, 99, 235, 0.39); }
      `}</style>
        </div>
    );
}
